import React, { useState, useEffect } from "react";
import { IonContent, IonPage, IonButton, IonText } from "@ionic/react";

// List of available shapes for the grow pattern
const shapes = ['⭐', '🌀', '◼', '🟡', '🔶', '🔺'];

const GrowingPatterns: React.FC = () => {
    const [sequence, setSequence] = useState<string[]>([]);
    const [correctAnswer, setCorrectAnswer] = useState<string | null>(null);
    const [options, setOptions] = useState<string[]>([]);
    const [userChoice, setUserChoice] = useState<string | null>(null);
    const [isCorrect, setIsCorrect] = useState<boolean | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);
    const [selectedOption, setSelectedOption] = useState<number | null>(null);

    // Function to generate the Grow pattern question with a missing element
    const generateMissingElementPatternQuestion = () => {
        const randomShape = shapes[Math.floor(Math.random() * shapes.length)]; // Random shape from the shapes array
        const sequenceLength = 5; // Length of the sequence before the user is asked for the next item
        const newSequence = Array.from({ length: sequenceLength }, (_, i) => randomShape.repeat(i + 1)); // Create the growing pattern

        // Randomly remove one element from the sequence
        const missingIndex = Math.floor(Math.random() * 5)
        const sequenceWithMissing = [...newSequence];
        const missingItem = sequenceWithMissing[missingIndex]; // Save the missing item

        // Set the missing item to "?" in the sequence
        sequenceWithMissing[missingIndex] = "?";

        // Generate the next shape in the pattern (next number of shapes in the sequence)
        const nextShape = randomShape.repeat(sequenceLength + 1); // Next shape (e.g., 6 stars)

        // Generate incorrect options for the missing element
        const incorrectOptions = generateIncorrectOptions(missingItem);

        // Update state
        setSequence(sequenceWithMissing); // Update the sequence with "?"
        setCorrectAnswer(missingItem); // Store the correct missing item
        setOptions(shuffleArray([missingItem, ...incorrectOptions])); // Shuffle options
        setUserChoice(null); // Reset user choice
        setIsCorrect(null); // Reset correctness
    };

    // Function to generate incorrect options for the missing element
    const generateIncorrectOptions = (correctAnswer: string) => {
        const incorrectOptions = new Set<string>();
        while (incorrectOptions.size < 2) {
            const randomShape = shapes[Math.floor(Math.random() * shapes.length)];
            const randomOption = randomShape.repeat(correctAnswer.length + Math.floor(Math.random() * 2) + 1); // Random shape of similar length but different from correct one
            if (randomOption !== correctAnswer) {
                incorrectOptions.add(randomOption);
            }
        }
        return Array.from(incorrectOptions);
    };

    // Shuffle the array for random options display
    const shuffleArray = (array: string[]) => {
        return [...array].sort(() => Math.random() - 0.5);
    };

    // Handle answer submission
    const handleAnswerSubmit = (selected: string) => {
        setUserChoice(selected);
        setIsCorrect(selected === correctAnswer);

        if (selected === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                generateMissingElementPatternQuestion(); // Generate a new question after a correct answer
                setShowImage(false);
                setError(false);
            }, 5000); // Delay before generating a new question
        }
        else {
            setError(true);
        }
    };

    useEffect(() => {
        generateMissingElementPatternQuestion(); // Generate the first pattern when the component mounts
        document.title = "Mamas Guidance - Class Two - Mathematics - Patterns - Growing Pattern"; // Set page title
    }, []);

    return (
        <>
        {
            showImage === false ?
            <>
                <div className="contentPart showCenter additionWord growingPattern">
                    <p style={{ fontSize: "1.5em" }}>
                        {sequence.join(" → ")} 
                    </p>
                    <div>What comes in place of &#34;?&#34;</div>
                    <div className="optionDiv" style={{ marginTop: "20px" }}>
                        {options.map((option, index) => (
                            <div
                                key={index}
                                onClick={() => handleAnswerSubmit(option)}
                                className={`mb-2 optionButton ${
                                    userChoice === option
                                    ? option === correctAnswer
                                        ? 'correct'
                                        : 'incorrect'
                                    : ''
                                        
                                }`}
                            >
                                {option}
                            </div>
                        ))}
                    </div>
                </div>
            </>
            :
            <>
                <div className="contentPart showMiddle">
                    <img style={{height: '150px'}} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                </div>
            </>
            }
        </>
    );
};

export default GrowingPatterns;
